import { CommonApiResponse } from "../../../Controllers/Types/ApiResponse";
import { completionCertificateResponse } from "../../../Controllers/Types/Project/DefaultService/CompletionCertificateResponce";
import { baseURL } from "../../ApiConstant";


export const completionCertificateGetDataApi = async (seriviceId : number): Promise<completionCertificateResponse> => {
    try {
        const token = localStorage.getItem('token');
        const FULL_TOKEN = `Bearer ${token}`;

        const response = await fetch(`${baseURL}/api/completion-certificate/${seriviceId}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': FULL_TOKEN
            },
        });

        const data = await response.json();

        if (response.status === 200) {
            return { status: true, statusCode: 200, data: data };
        } else if (response.status === 401) {
            return { status: false, statusCode: 401, massage: "Unauthorized" };
        } else if (response.status === 422) {
            return { status: false, statusCode: 422, massage: "Body error" };
        } else if (response.status === 404) {
            return { status: false, statusCode: 404, massage: "Not found" };
        } else {
            return { status: false, statusCode: 500, massage: "Error" };
        }

    } catch (error) {
        throw error;
    }
}

export const completionCertificateCreateAPI = async (folder_id: number, certificate_title: string, applied_date: string | null, status: string, path: File): Promise<CommonApiResponse> => {
    try {
        const token = localStorage.getItem('token');
        const FULL_TOKEN = `Bearer ${token}`;

        /* create form data */
        const formData = new FormData();
        formData.append('folder_id', folder_id.toString());
        formData.append('certificate_title', certificate_title);
        if (applied_date) {
            formData.append('applied_date', applied_date); 
        }
        formData.append('status', status); 
        if (path) {
            formData.append('path', path);
        }

        const response = await fetch(`${baseURL}/api/completion-certificate/create`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Authorization': FULL_TOKEN
            },
            body: formData,

        });
        

        const data = await response.json();        

        if (response.status === 200) {
            return { status: true, statusCode: 200 };
        } else if (response.status === 401) {
            return { status: false, statusCode: 401, massage: "Unauthorized" };
        } else if (response.status === 422) {
            return { status: false, statusCode: 422, errors: data['errors'], massage: "Body error" };
        } else if (response.status === 404) {
            return { status: false, statusCode: 404, massage: "Not found" };
        } else {
            return { status: false, statusCode: 500, massage: "Error" };
        }

    } catch (error) {
        throw error;
    }
};

export const completionCertificateUpdateAPI = async (certificateId: number, certificate_title: string, applied_date: string | null, status: string, path: File): Promise<CommonApiResponse> => {
    try {
        const token = localStorage.getItem('token');
        const FULL_TOKEN = `Bearer ${token}`;

        /* create form data */
        const formData = new FormData();
        formData.append('certificate_title', certificate_title);
        if (applied_date) {
            formData.append('applied_date', applied_date); 
        }
        formData.append('status', status); 
        if (path) {
            formData.append('path', path);
        }

        const response = await fetch(`${baseURL}/api/completion-certificate/update/${certificateId}`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Authorization': FULL_TOKEN
            },
            body: formData,

        });
        

        const data = await response.json();        

        if (response.status === 200) {
            return { status: true, statusCode: 200 };
        } else if (response.status === 401) {
            return { status: false, statusCode: 401, massage: "Unauthorized" };
        } else if (response.status === 422) {
            return { status: false, statusCode: 422, errors: data['errors'], massage: "Body error" };
        } else if (response.status === 404) {
            return { status: false, statusCode: 404, massage: "Not found" };
        } else {
            return { status: false, statusCode: 500, massage: "Error" };
        }

    } catch (error) {
        throw error;
    }
};

export const completionCertificateDeleteAPI = async (certificateId: number): Promise<CommonApiResponse> => {
    try {        
        const token = localStorage.getItem('token');
        const FULL_TOKEN = `Bearer ${token}`;
        const response = await fetch(`${baseURL}/api/completion-certificate/delete/${certificateId}`, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': FULL_TOKEN
            }
        });
        
        const data = await response.json();

        if (response.status === 200) {
            return { status: true, statusCode: 200 };
        } else if (response.status === 401) {
            return { status: false, statusCode: 401, massage: "Unauthorized" };
        } else if (response.status === 422) {
            return { status: false, statusCode: 422, errors: data['errors'], massage: "Body error" };
        } else if (response.status === 404) {
            return { status: false, statusCode: 404, massage: "Not found" };
        } else {
            return { status: false, statusCode: 500, massage: "Error" };
        }

    } catch (error) {
        throw error;
    }
};